<template>
  <v-dialog scrollable class="dialog" v-model="config.status.active">
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar flat color="secondary white--text">
          <v-toolbar-title>ファイルの読み込み</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn v-if="isPageMain" depressed
            color="white secondary--text"
            @click="openConfig"
          >
            <v-icon small>fa-cog</v-icon>&nbsp;読み込み設定
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text>
        <v-window v-model="config.page">
          <v-window-item value="main">
            <Filer v-if="getRootId && config.status.active"
              :rid="getRootId"
              :filters="{ extensions: ['xls', 'xlsx'] }"
              :permits="{ add: true }"
              @select="select"
            />
          </v-window-item>
          <v-window-item value="confirm">
            <l-confirm :item="getItem" />
          </v-window-item>
        </v-window>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions v-if="isPageMain">
        <v-btn text
          color="secondary"
          @click="close">閉じる</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed
          color="secondary"
          :loading="isLoading"
          :disabled="!isValid"
          @click="read">読み込む</v-btn>
      </v-card-actions>
      <v-card-actions v-else-if="isPageConfirm">
        <v-btn text
          color="secondary"
          @click="back">戻る</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed
          color="secondary"
          @click="done">適用する</v-btn>
      </v-card-actions>
      <ConfigModal ref="config" @done="updateConfig" />
    </v-card>
  </v-dialog>
</template>

<script>
import Filer from '@/components/filers/client'
import ConfigModal from './modals/config'
import LConfirm from './layouts/confirm'
const DEF = {
  PAGE: 'main'
}
export default {
  name: 'ProgramReaderModal',
  components: {
    Filer,
    ConfigModal,
    LConfirm
  },
  data () {
    return {
      config: {
        page: DEF.PAGE,
        status: {
          active: false,
          loading: false
        }
      },
      form: {
        valid: false
      },
      store: {
        config: {},
        items: [],
        item: {}
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init: function () {
    },
    open: function () {
      this.$set(this.config, 'page', DEF.PAGE)
      this.$set(this.config.status, 'active', true)
      this.$nextTick(() => {
        this.select()
        this.$set(this.store, 'config', this.$refs.config.getForm())
      })
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    back: function () {
      this.$set(this.config, 'page', 'main')
    },
    read: function () {
      const it = this.store.items[0] || {}
      if (it.id) {
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(`${this.$url.api}apply/read/${it.id}`, {
            config: this.store.config
          }, {
            headers: {
              'firebase-token': token
            },
            onUploadProgress: (e) => {
              this.$set(this.config.status, 'loading', Math.ceil(e.loaded / e.total * 100))
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$set(this.config.status, 'loading', false)
              this.$set(this.store, 'item', res.data.data)
              this.$set(this.config, 'page', 'confirm')
            } else {
              this.$set(this.config.status, 'loading', false)
            }
          })
        }).catch(err => {
          console.log(err)
          this.$set(this.config.status, 'loading', false)
        })
      }
    },
    done: function () {
      this.$emit('done', { item: this.store.item })
      this.close()
    },
    select: function (items) {
      let selects = items ? items.filter(it => {
        return (it.id && it.type && it.type !== 'folder')
      }) : this.store.items
      this.$set(this.store, 'items', selects)
      this.$set(this.form, 'valid', selects.length === 1)
    },
    openConfig: function () {
      this.$refs.config.open()
    },
    updateConfig: function (data) {
      this.$set(this.store, 'config', data)
    }
  },
  computed: {
    isLoading () {
      return Number.isFinite(this.config.status.loading) || this.config.status.loading
    },
    isValid () {
      return this.form.valid
    },
    isPageMain () {
      return this.config.page === 'main'
    },
    isPageConfirm () {
      return this.config.page === 'confirm'
    },
    getRootId () {
      return this.$store.getters['client/get']('lib').media
    },
    getItem () {
      return this.store.item
    }
  }
}
</script>